export default function NetworksSection() {
  const networks = [
    { icon: "ri-facebook-fill", name: "Facebook", color: "#1877F2" },
    { icon: "ri-instagram-line", name: "Instagram", color: "#E1306C" },
    { icon: "ri-twitter-x-fill", name: "X / Twitter", color: "#ffffff" },
    { icon: "ri-linkedin-fill", name: "LinkedIn", color: "#0A66C2" },
    { icon: "ri-youtube-fill", name: "YouTube", color: "#FF0000" },
    { icon: "ri-tiktok-fill", name: "TikTok", color: "#ffffff" },
    { icon: "ri-pinterest-fill", name: "Pinterest", color: "#E60023" },
    { icon: "ri-threads-fill", name: "Threads", color: "#ffffff" },
    { icon: "ri-reddit-fill", name: "Reddit", color: "#FF4500" },
    { icon: "ri-telegram-fill", name: "Telegram", color: "#26A5E4" },
    { icon: "ri-cloud-line", name: "Bluesky", color: "#0085FF" },
    { icon: "ri-medium-fill", name: "Medium", color: "#ffffff" },
  ];

  return (
    <section
      className="relative py-20 overflow-hidden"
      style={{
        background: "linear-gradient(135deg, #1e0533 0%, #2d0a4e 30%, #1a1060 60%, #0d1a4a 100%)",
      }}
    >
      {/* Decorative blobs */}
      <div
        className="absolute top-0 left-1/4 w-96 h-96 rounded-full opacity-20 blur-3xl pointer-events-none"
        style={{ background: "radial-gradient(circle, #a855f7, transparent)" }}
      />
      <div
        className="absolute bottom-0 right-1/4 w-80 h-80 rounded-full opacity-15 blur-3xl pointer-events-none"
        style={{ background: "radial-gradient(circle, #ec4899, transparent)" }}
      />
      <div
        className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[300px] rounded-full opacity-10 blur-3xl pointer-events-none"
        style={{ background: "radial-gradient(ellipse, #6366f1, transparent)" }}
      />

      <div className="relative max-w-7xl mx-auto px-5 md:px-8">
        {/* Heading */}
        <div className="text-center mb-12">
          <span className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-white/10 text-violet-200 text-xs font-semibold uppercase tracking-widest mb-5 border border-white/10">
            <i className="ri-global-line"></i>
            Reach Everywhere
          </span>
          <h2 className="text-2xl md:text-4xl font-bold text-white mb-3">
            One Dashboard.{" "}
            <span className="bg-gradient-to-r from-violet-400 to-fuchsia-400 bg-clip-text text-transparent">
              30+ Networks &amp; Sites.
            </span>
          </h2>
          <p className="text-white/60 text-base max-w-xl mx-auto">
            ClickSendAI posts to every major social platform, video site, blog network, and community
            directory — automatically, every single day.
          </p>
        </div>

        {/* Network icons */}
        <div className="flex flex-wrap items-center justify-center gap-5 md:gap-8 mb-10">
          {networks.map((net) => (
            <div
              key={net.name}
              className="flex flex-col items-center gap-2 group cursor-pointer"
            >
              <div
                className="w-14 h-14 flex items-center justify-center rounded-2xl transition-all duration-300 group-hover:scale-110"
                style={{
                  background: "rgba(255,255,255,0.07)",
                  border: "1px solid rgba(255,255,255,0.12)",
                  boxShadow: `0 0 20px ${net.color}22`,
                }}
              >
                <i
                  className={`${net.icon} text-2xl`}
                  style={{ color: net.color }}
                ></i>
              </div>
              <span className="text-xs text-white/50 group-hover:text-white/90 transition-colors">
                {net.name}
              </span>
            </div>
          ))}

          {/* +More badge */}
          <div className="flex flex-col items-center gap-2">
            <div
              className="w-14 h-14 flex items-center justify-center rounded-2xl"
              style={{
                background: "linear-gradient(135deg, rgba(167,139,250,0.25), rgba(232,121,249,0.25))",
                border: "1px solid rgba(167,139,250,0.3)",
              }}
            >
              <span className="text-sm font-bold text-violet-300">+18</span>
            </div>
            <span className="text-xs text-white/50">More</span>
          </div>
        </div>

        {/* Stats strip */}
        <div className="flex flex-wrap justify-center gap-8 md:gap-16">
          {[
            { value: "30+", label: "Networks & sites" },
            { value: "100%", label: "Automated posting" },
            { value: "24/7", label: "Always publishing" },
          ].map((s) => (
            <div key={s.label} className="text-center">
              <p className="text-2xl md:text-3xl font-bold bg-gradient-to-r from-violet-300 to-fuchsia-300 bg-clip-text text-transparent">
                {s.value}
              </p>
              <p className="text-white/50 text-sm mt-1">{s.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
